import React from 'react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'

// lib
import { makeFichaAvisoURL } from '@navent-jobs/interlinking'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import Text from '@navent-jobs/ui-kit/components/text'

// components
import CardPlaceholder from '../../../../components/card/CardPlaceholder'
import AdFichaGoogleList from '../ads/AdFichaGoogleList'

// mixins
import { Header, EmpleosRelacionadosContainer, EmpleosRelacionadosComponent, ListadoAvisoCard } from './mixins'

// constants
import { SITE_ID } from '../../../../constants'
import features from '../../../../constants/features-per-country'
import { DataLayers as PageDataLayers } from '../../../../constants/gtm-events-ficha-aviso-page'

const CONFIDENCIAL = 'Confidencial'

const googleAdsEnabled = features[SITE_ID || 'BMAR'].googleAds?.ficha?.enabled

const handleMetrics = (empleo, index: number) => {
  PageDataLayers.empleosRelacionadosOnClick(empleo, index)
}

const EmpleosRelacionados = ({ aviso, avisosSimilares, loading, productoLookAndFeel }) => {
  const { t } = useTranslation()
  const { isDesktop } = useScreenSize()

  const thirdPositionInList = 2

  if (!avisosSimilares && !loading) {
    return null
  }

  return (
    <EmpleosRelacionadosContainer>
      <EmpleosRelacionadosComponent>
        <Header>
          <Text size="lg" fontWeight="semibold" variant="secondary" as="h3">
            {aviso && productoLookAndFeel
              ? `Avisos de ${aviso.empresa.denominacion}`
              : t('fichaAviso.avisosRelacionados')}
          </Text>
        </Header>

        {loading &&
          [...Array(5)].map((e, i) => {
            // eslint-disable-next-line react/no-array-index-key
            return <CardPlaceholder key={i} />
          })}

        {avisosSimilares &&
          avisosSimilares.map((empleo, index) => {
            return (
              <>
                {index === thirdPositionInList && isDesktop && googleAdsEnabled && <AdFichaGoogleList />}

                <ListadoAvisoCard
                  key={empleo.id}
                  aviso={empleo}
                  index={index}
                  ubicacion="Ficha de aviso"
                  handleMetrics={() => handleMetrics(empleo, index + 1)}
                  link={makeFichaAvisoURL({
                    ...empleo,
                    empresa: { denominacion: empleo.empresa, confidencial: empleo.empresa === CONFIDENCIAL },
                  })}
                />
              </>
            )
          })}
      </EmpleosRelacionadosComponent>
    </EmpleosRelacionadosContainer>
  )
}

const states = ({ activeAvisoStore }) => {
  const { aviso, avisosSimilares, loading, productoLookAndFeel } = activeAvisoStore
  return {
    aviso,
    avisosSimilares,
    loading,
    productoLookAndFeel,
  }
}

export default connect(states)(EmpleosRelacionados)
